module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/homes_ttl-afd370ee40790fafd43b00c05ccba11b.svg";